// extracted by mini-css-extract-plugin
export default {"wrap":"hI-z","articleImagesWrap":"iI-z","articleImage":"jI-z","singleImage":"kI-z"};